<template>
  <div>
    <!-- 大星 -->
    <div class="stars" v-if="!small">
      <div class="commentTag">{{ commentText }}</div>
      <div class="starWrap">
        <div class="starColumn">
          <i class="DYT_icon_font" :class="fullIcon" v-for="(i, index) in fullNum" :key="index"></i>
          <i class="DYT_icon_font" :class="halfIconStyle" v-for="(i, index) in halfNum" :key="index"></i>
          <i class="DYT_icon_font" :class="emptyIcon" style="color: #a2e0e0" v-for="(i, index) in emptyNum" :key="index"></i>
        </div>
        <div class="starColumn hiddenStar">
          <i class="DYT_icon_font" :class="emptyIcon" v-for="i in 5" :key="i" @click="selectStar(i)"></i>
        </div>
        <!-- 需要调用一次以更新DOM -->
        <span v-show="false">{{ num }}</span>
      </div>
    </div>

    <!-- 小星 -->
    <div class="stars small" v-if="small">
      <div class="starWrap">
        <div class="starColumn">
          <i class="DYT_icon_font" :class="fullIcon" v-for="(i, index) in fullNum" :key="index"></i>
          <i class="DYT_icon_font" :class="halfIconStyle" v-for="(i, index) in halfNum" :key="index"></i>
          <i class="DYT_icon_font" :class="emptyIcon" style="color: #a2e0e0" v-for="(i, index) in emptyNum" :key="index"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['num', 'canclick', 'small', 'noTitle'],
  data() {
    return {
      fullIcon: 'icon-huixing1',
      halfIcon: 'icon-banxing1',
      halfIcon2: 'icon-xing',
      halfIcon3: 'icon-xing1',
      emptyIcon: 'icon-huixing1',
      intPart: 0,
      decPart: 0,
      len: 10,
      commentTexts: ['差评', '中评', '好评'],
      commentText: ''
    }
  },
  computed: {
    halfIconStyle() {
      if (this.decPart <= 0.25 && this.decPart > 0) {
        return this.halfIcon2 // 1/4
      } else if (this.decPart <= 0.5 && this.decPart > 0.25) {
        return this.halfIcon // 1/2
      } else if (this.decPart <= 0.75 && this.decPart > 0.5) {
        return this.halfIcon3 // 3/4
      }
    },
    fullNum() {
      return this.decPart > 0.75 ? parseInt(this.intPart) + 1 : parseInt(this.intPart)
    },
    halfNum() {
      return parseInt(this.decPart <= 0.75 && this.decPart > 0 ? 1 : 0)
    },
    emptyNum() {
      return parseInt(5 - this.fullNum - this.halfNum)
    }
  },
  created() {
    this.calcStars()
  },
  updated() {
    this.calcStars()
  },
  methods: {
    selectStar(i) {
      if (this.canclick) {
        this.intPart = i
        this.decPart = 0
        this.calcCommentText()
        this.$emit('selectStar', i)
      }
    },
    calcCommentText() {
      if (this.intPart === 0) {
        this.commentText = ''
      } else if (this.intPart <= 1) {
        this.commentText = this.commentTexts[0]
      } else if (this.intPart <= 3) {
        this.commentText = this.commentTexts[1]
      } else {
        this.commentText = this.commentTexts[2]
      }
    },
    calcStars() {
      if (this.num) {
        this.intPart = Math.floor(parseInt(this.num))
        this.decPart = this.num % 1
      } else {
        this.intPart = 0
        this.decPart = 0
      }
      this.calcCommentText()
    }
  }
}
</script>

<style scoped lang="less">
.stars {
  .commentTag {
    min-height: 2em;
    text-align: center;
    font-size: 0.76rem;
    color: #f7a073;
  }
  .starWrap {
    position: relative;
    .starColumn {
      height: 2rem;
      text-align: center;
      .DYT_icon_font {
        color: #f7a073;
        font-size: 1.4rem;
        margin-right: 0.1rem;
      }
      &.hiddenStar {
        margin-top: -2rem;
        opacity: 0;
      }
    }
  }
  &.small {
    .starWrap .starColumn {
      text-align: left;
      height: 3em;
      line-height: 2em;
      .DYT_icon_font {
        font-size: 1.4em;
      }
    }
  }
}
</style>
